<template>
	<div class="picture-wrapper__bundle">
		<ProviderIcon
			v-for="icon in packageIcons"
			:key="icon.iconWide"
			:iconUrl="icon.iconWide"
			:providerShortName="icon.shortName"
			class="icon"
		/>
	</div>
</template>

<script setup lang="ts">
import ProviderIcon from '@/components/picture/ProviderIcon.vue';

defineProps<{ packageIcons: { iconWide: string; shortName: string }[] }>();
</script>

<style lang="scss" scoped>
.picture-wrapper__bundle {
	display: flex;
	flex-direction: column;

	.icon {
		position: relative;
		margin-inline-start: 32px;
		margin-top: -5px;

		:deep(img.provider-icon.wide) {
			height: unset;
			min-width: unset;
			min-height: unset;
			border-radius: 4px;
		}
	}

	:first-child {
		margin-top: 0px;

		:deep(img.provider-icon.wide) {
			width: 56px;
		}

		& ~ picture {
			:deep(img.provider-icon.wide) {
				width: 48px;
			}
		}
	}

	:nth-child(odd) {
		margin-inline-start: 0px;
	}
}
</style>
